import Vue from 'vue';
import * as api from '~/api/resource'

export const state = {
    type: '',
    rooms: [],
    bookingRoomTags: [],
    hotelConfiguration:{}

}

export const getters = {
    rooms: state => state.rooms,
    bookingRoomTags: state => state.bookingRoomTags,
    // columns : state => state.columns,
    // search : state => state.search,

    // total : state => state.total,
    // list : state => state.list.map(id => state.entities[id.toString()]),

    // byId : state => id => state.entities[_.toString(id)],
}

export const mutations = {
    // setTotal (state, total){
    //     state.total = total
    // },
    // setType (state, type){
    //     state.type = type
    // },
    setRooms(state, rooms) {
        state.rooms = rooms
    },
    setHotelConfiguration(state, conf) {
        state.hotelConfiguration = conf
    },
    bookingRoomTags(state, bookingRoomTags) {
        state.bookingRoomTags = bookingRoomTags
    },
    // setList (state, list){
    //     list.forEach((m) => {
    //         // const obj = Object.assign({}, state.entities[m['id'].toString()], m)
    //         const obj = _.merge({}, state.entities[m['id'].toString()], m)
    //         Vue.set(state.entities, m['id'].toString(), obj);
    //       });
    //     state.list = list.map(m => m['id'].toString());
    // },
    // setSingle(state, data){
    //     // const obj = Object.assign({}, state.entities[data['id'].toString()], data)
    //     const obj = _.merge({}, state.entities[data['id'].toString()], data)
    //     Vue.set(state.entities, data['id'].toString(), obj);
    // }
}

export const actions = {
    fetchRooms({ commit }) {
        return api.fetchList('rooms').then(({ data }) => {
            commit('setRooms', data.results)

        })
    },
    fetchConfiguration({ commit }) {
        return api.fetchObject('hotel').then(({ data }) => {

            commit('setHotelConfiguration', data.object)
            return data.object
        })
    },
    fetchAvailableBookingTags({ commit }) {
        return api.fetchProcessor('gears/gettags', { type: 'bookingroomtags' }).then(({ data }) => {
            commit('bookingRoomTags', data.results)

        })
    },
    fetchSingle({ commit }, payload) {
        return api.fetchObject(state.type, payload).then(({ data }) => {
            commit('setSingle', data.object)
        })
    }
}